/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getDeviceDetails = /* GraphQL */ `
  query GetDeviceDetails(
    $deviceId: String
    $startDate: String!
    $endDate: String!
    $isAmPm: Boolean
    $variableName: String!
    $variableDerived: Boolean
    $groupBy: String
    $graphBy: String
    $companyId: String
    $branchId: String
    $lastValue: Boolean
  ) {
    getDeviceDetails(
      deviceId: $deviceId
      startDate: $startDate
      endDate: $endDate
      isAmPm: $isAmPm
      variableName: $variableName
      variableDerived: $variableDerived
      groupBy: $groupBy
      graphBy: $graphBy
      companyId: $companyId
      branchId: $branchId
      lastValue: $lastValue
    ) {
      labels
      data
      xAxisLabel
      __typename
    }
  }
`;
export const getDashboardStandard = /* GraphQL */ `
  query GetDashboardStandard(
    $companies: [String]
    $branches: [String]
    $variables: [String]
    $time: String
  ) {
    getDashboardStandard(
      companies: $companies
      branches: $branches
      variables: $variables
      time: $time
    ) {
      success
      data {
        deviceID
        deviceName
        branchID
        companyID
        variables {
          name
          value
          __typename
        }
        __typename
      }
      error
      __typename
    }
  }
`;
export const getServiceOrderPhoto = /* GraphQL */ `
  query GetServiceOrderPhoto($id: ID!) {
    getServiceOrderPhoto(id: $id) {
      id
      serviceOrderID
      photo
      tag
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listServiceOrderPhotos = /* GraphQL */ `
  query ListServiceOrderPhotos(
    $filter: ModelServiceOrderPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceOrderPhotos(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderID
        photo
        tag
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderPhotosByServiceOrderID = /* GraphQL */ `
  query ServiceOrderPhotosByServiceOrderID(
    $serviceOrderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderPhotoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderPhotosByServiceOrderID(
      serviceOrderID: $serviceOrderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderID
        photo
        tag
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getExecutedServiceOrder = /* GraphQL */ `
  query GetExecutedServiceOrder($id: ID!) {
    getExecutedServiceOrder(id: $id) {
      id
      serviceOrderID
      userExecutor
      executedRoutines {
        equipmentID
        routineID
        activities {
          activityID
          activityValue
          __typename
        }
        __typename
      }
      observations
      deletedAt
      createdAt
      executionStartedAt
      executionEndedAt
      updatedAt
      __typename
    }
  }
`;
export const listExecutedServiceOrders = /* GraphQL */ `
  query ListExecutedServiceOrders(
    $filter: ModelExecutedServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExecutedServiceOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderID
        userExecutor
        executedRoutines {
          equipmentID
          routineID
          __typename
        }
        observations
        deletedAt
        createdAt
        executionStartedAt
        executionEndedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const executedServiceOrdersByServiceOrderID = /* GraphQL */ `
  query ExecutedServiceOrdersByServiceOrderID(
    $serviceOrderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelExecutedServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    executedServiceOrdersByServiceOrderID(
      serviceOrderID: $serviceOrderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderID
        userExecutor
        executedRoutines {
          equipmentID
          routineID
          __typename
        }
        observations
        deletedAt
        createdAt
        executionStartedAt
        executionEndedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const executedServiceOrdersByUserExecutor = /* GraphQL */ `
  query ExecutedServiceOrdersByUserExecutor(
    $userExecutor: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelExecutedServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    executedServiceOrdersByUserExecutor(
      userExecutor: $userExecutor
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderID
        userExecutor
        executedRoutines {
          equipmentID
          routineID
          __typename
        }
        observations
        deletedAt
        createdAt
        executionStartedAt
        executionEndedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      maintenanceRoutineID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        type
        values
        abbreviation
        unit
        defaultValue
        maintenanceRoutineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activitiesByMaintenanceRoutineID = /* GraphQL */ `
  query ActivitiesByMaintenanceRoutineID(
    $maintenanceRoutineID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByMaintenanceRoutineID(
      maintenanceRoutineID: $maintenanceRoutineID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        values
        abbreviation
        unit
        defaultValue
        maintenanceRoutineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMaintenanceRoutine = /* GraphQL */ `
  query GetMaintenanceRoutine($id: ID!) {
    getMaintenanceRoutine(id: $id) {
      id
      name
      description
      activities {
        items {
          id
          name
          description
          type
          values
          abbreviation
          unit
          defaultValue
          maintenanceRoutineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      serviceOrders {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      activitiesOrder
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMaintenanceRoutines = /* GraphQL */ `
  query ListMaintenanceRoutines(
    $filter: ModelMaintenanceRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMaintenanceRoutines(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        activities {
          nextToken
          __typename
        }
        companyID
        serviceOrders {
          nextToken
          __typename
        }
        activitiesOrder
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const maintenanceRoutinesByCompanyID = /* GraphQL */ `
  query MaintenanceRoutinesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMaintenanceRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    maintenanceRoutinesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        activities {
          nextToken
          __typename
        }
        companyID
        serviceOrders {
          nextToken
          __typename
        }
        activitiesOrder
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpareParameter = /* GraphQL */ `
  query GetSpareParameter($id: ID!) {
    getSpareParameter(id: $id) {
      id
      spareID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpareParameters = /* GraphQL */ `
  query ListSpareParameters(
    $filter: ModelSpareParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpareParameters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        spareID
        parameterID
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const spareParametersBySpareID = /* GraphQL */ `
  query SpareParametersBySpareID(
    $spareID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpareParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spareParametersBySpareID(
      spareID: $spareID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spareID
        parameterID
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const spareParametersByParameterID = /* GraphQL */ `
  query SpareParametersByParameterID(
    $parameterID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpareParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    spareParametersByParameterID(
      parameterID: $parameterID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        spareID
        parameterID
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpare = /* GraphQL */ `
  query GetSpare($id: ID!) {
    getSpare(id: $id) {
      id
      name
      description
      status
      location
      companyID
      serviceOrderID
      equipmentID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSpares = /* GraphQL */ `
  query ListSpares(
    $filter: ModelSpareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpares(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        status
        location
        companyID
        serviceOrderID
        equipmentID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sparesByCompanyID = /* GraphQL */ `
  query SparesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sparesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        status
        location
        companyID
        serviceOrderID
        equipmentID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sparesByServiceOrderID = /* GraphQL */ `
  query SparesByServiceOrderID(
    $serviceOrderID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sparesByServiceOrderID(
      serviceOrderID: $serviceOrderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        status
        location
        companyID
        serviceOrderID
        equipmentID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sparesByEquipmentID = /* GraphQL */ `
  query SparesByEquipmentID(
    $equipmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSpareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sparesByEquipmentID(
      equipmentID: $equipmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        status
        location
        companyID
        serviceOrderID
        equipmentID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getToolParameter = /* GraphQL */ `
  query GetToolParameter($id: ID!) {
    getToolParameter(id: $id) {
      id
      toolID
      parameterID
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listToolParameters = /* GraphQL */ `
  query ListToolParameters(
    $filter: ModelToolParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listToolParameters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        toolID
        parameterID
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const toolParametersByToolID = /* GraphQL */ `
  query ToolParametersByToolID(
    $toolID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelToolParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    toolParametersByToolID(
      toolID: $toolID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        toolID
        parameterID
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const toolParametersByParameterID = /* GraphQL */ `
  query ToolParametersByParameterID(
    $parameterID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelToolParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    toolParametersByParameterID(
      parameterID: $parameterID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        toolID
        parameterID
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTool = /* GraphQL */ `
  query GetTool($id: ID!) {
    getTool(id: $id) {
      id
      name
      description
      location
      companyID
      technicianID
      serviceOrders {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTools = /* GraphQL */ `
  query ListTools(
    $filter: ModelToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const toolsByCompanyID = /* GraphQL */ `
  query ToolsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    toolsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const toolsByTechnicianID = /* GraphQL */ `
  query ToolsByTechnicianID(
    $technicianID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    toolsByTechnicianID(
      technicianID: $technicianID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getManagedCompany = /* GraphQL */ `
  query GetManagedCompany($id: ID!) {
    getManagedCompany(id: $id) {
      id
      parentID
      childID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listManagedCompanies = /* GraphQL */ `
  query ListManagedCompanies(
    $filter: ModelManagedCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listManagedCompanies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentID
        childID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const managedCompaniesByParentID = /* GraphQL */ `
  query ManagedCompaniesByParentID(
    $parentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelManagedCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    managedCompaniesByParentID(
      parentID: $parentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentID
        childID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const managedCompaniesByChildID = /* GraphQL */ `
  query ManagedCompaniesByChildID(
    $childID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelManagedCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    managedCompaniesByChildID(
      childID: $childID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentID
        childID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCostCenter = /* GraphQL */ `
  query GetCostCenter($id: ID!) {
    getCostCenter(id: $id) {
      id
      code
      name
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCostCenters = /* GraphQL */ `
  query ListCostCenters(
    $filter: ModelCostCenterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCostCenters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name
        companyID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const costCentersByCompanyID = /* GraphQL */ `
  query CostCentersByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCostCenterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    costCentersByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        name
        companyID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceOrder = /* GraphQL */ `
  query GetServiceOrder($id: ID!) {
    getServiceOrder(id: $id) {
      id
      code
      description
      billDate
      billValue
      billCurrency
      companyID
      branchID
      equipments {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      equipmentRoutines {
        equipmentID
        routineID
        __typename
      }
      equipmentSpares {
        equipmentID
        spares
        __typename
      }
      costCenterID
      title
      color
      observations
      userExecutor
      status
      start
      end
      tools {
        items {
          id
          toolId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      maintenanceRoutines {
        items {
          id
          maintenanceRoutineId
          serviceOrderId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      auxExecutors
      geolocation
      photoRequired
      createdAt
      deletedAt
      updatedAt
      __typename
    }
  }
`;
export const listServiceOrders = /* GraphQL */ `
  query ListServiceOrders(
    $filter: ModelServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrdersByCompanyID = /* GraphQL */ `
  query ServiceOrdersByCompanyID(
    $companyID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrdersByCompanyID(
      companyID: $companyID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrdersByBranchID = /* GraphQL */ `
  query ServiceOrdersByBranchID(
    $branchID: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrdersByBranchID(
      branchID: $branchID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrdersByCostCenterID = /* GraphQL */ `
  query ServiceOrdersByCostCenterID(
    $costCenterID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrdersByCostCenterID(
      costCenterID: $costCenterID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrdersByUserExecutor = /* GraphQL */ `
  query ServiceOrdersByUserExecutor(
    $userExecutor: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrdersByUserExecutor(
      userExecutor: $userExecutor
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEquipmentDocument = /* GraphQL */ `
  query GetEquipmentDocument($id: ID!) {
    getEquipmentDocument(id: $id) {
      id
      equipmentID
      fileSrc
      fileName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEquipmentDocuments = /* GraphQL */ `
  query ListEquipmentDocuments(
    $filter: ModelEquipmentDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEquipmentDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        equipmentID
        fileSrc
        fileName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentDocumentsByEquipmentID = /* GraphQL */ `
  query EquipmentDocumentsByEquipmentID(
    $equipmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentDocumentsByEquipmentID(
      equipmentID: $equipmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        equipmentID
        fileSrc
        fileName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEquipmentParameter = /* GraphQL */ `
  query GetEquipmentParameter($id: ID!) {
    getEquipmentParameter(id: $id) {
      id
      equipmentID
      parameterID
      parameterName
      parameterValue
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEquipmentParameters = /* GraphQL */ `
  query ListEquipmentParameters(
    $filter: ModelEquipmentParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEquipmentParameters(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        equipmentID
        parameterID
        parameterName
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentParametersByEquipmentID = /* GraphQL */ `
  query EquipmentParametersByEquipmentID(
    $equipmentID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentParametersByEquipmentID(
      equipmentID: $equipmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        equipmentID
        parameterID
        parameterName
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentParametersByParameterID = /* GraphQL */ `
  query EquipmentParametersByParameterID(
    $parameterID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentParametersByParameterID(
      parameterID: $parameterID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        equipmentID
        parameterID
        parameterName
        parameterValue
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEquipment = /* GraphQL */ `
  query GetEquipment($id: ID!) {
    getEquipment(id: $id) {
      id
      name
      location
      description
      companyID
      branchID
      deviceID
      spares {
        items {
          id
          name
          description
          status
          location
          companyID
          serviceOrderID
          equipmentID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      serviceOrders {
        items {
          id
          serviceOrderId
          equipmentId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      coordsLat
      coordsLng
      routineID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEquipment = /* GraphQL */ `
  query ListEquipment(
    $filter: ModelEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEquipment(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentByCompanyID = /* GraphQL */ `
  query EquipmentByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentByBranchID = /* GraphQL */ `
  query EquipmentByBranchID(
    $branchID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentByBranchID(
      branchID: $branchID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentByDeviceID = /* GraphQL */ `
  query EquipmentByDeviceID(
    $deviceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentByDeviceID(
      deviceID: $deviceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const equipmentByRoutineID = /* GraphQL */ `
  query EquipmentByRoutineID(
    $routineID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    equipmentByRoutineID(
      routineID: $routineID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getParameter = /* GraphQL */ `
  query GetParameter($id: ID!) {
    getParameter(id: $id) {
      id
      name
      description
      type
      values
      abbreviation
      unit
      defaultValue
      companyID
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listParameters = /* GraphQL */ `
  query ListParameters(
    $filter: ModelParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listParameters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        type
        values
        abbreviation
        unit
        defaultValue
        companyID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const parametersByCompanyID = /* GraphQL */ `
  query ParametersByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelParameterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    parametersByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        type
        values
        abbreviation
        unit
        defaultValue
        companyID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHoliday = /* GraphQL */ `
  query GetHoliday($id: ID!) {
    getHoliday(id: $id) {
      id
      date
      name
      deletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHolidays = /* GraphQL */ `
  query ListHolidays(
    $filter: ModelHolidayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHolidays(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        date
        name
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRuleLog = /* GraphQL */ `
  query GetRuleLog($id: ID!) {
    getRuleLog(id: $id) {
      id
      ruleID
      name
      description
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRuleLogs = /* GraphQL */ `
  query ListRuleLogs(
    $filter: ModelRuleLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRuleLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ruleID
        name
        description
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ruleLogsByRuleID = /* GraphQL */ `
  query RuleLogsByRuleID(
    $ruleID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ruleLogsByRuleID(
      ruleID: $ruleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleID
        name
        description
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ruleLogsByCompanyID = /* GraphQL */ `
  query RuleLogsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ruleLogsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleID
        name
        description
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ruleLogsByBranchID = /* GraphQL */ `
  query RuleLogsByBranchID(
    $branchID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ruleLogsByBranchID(
      branchID: $branchID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleID
        name
        description
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ruleLogsByDeviceID = /* GraphQL */ `
  query RuleLogsByDeviceID(
    $deviceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ruleLogsByDeviceID(
      deviceID: $deviceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleID
        name
        description
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRule = /* GraphQL */ `
  query GetRule($id: ID!) {
    getRule(id: $id) {
      id
      name
      description
      action
      actionValue
      devices {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRules = /* GraphQL */ `
  query ListRules(
    $filter: ModelRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        action
        actionValue
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rulesByCompanyID = /* GraphQL */ `
  query RulesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rulesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        action
        actionValue
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAlertLog = /* GraphQL */ `
  query GetAlertLog($id: ID!) {
    getAlertLog(id: $id) {
      id
      alertID
      name
      description
      severity
      severityColor
      status
      companyID
      companyName
      branchID
      branchName
      deviceID
      deviceName
      notificationsSent
      recognizedByUser
      recognizedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAlertLogs = /* GraphQL */ `
  query ListAlertLogs(
    $filter: ModelAlertLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlertLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        alertID
        name
        description
        severity
        severityColor
        status
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        recognizedByUser
        recognizedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertLogsByAlertID = /* GraphQL */ `
  query AlertLogsByAlertID(
    $alertID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertLogsByAlertID(
      alertID: $alertID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertID
        name
        description
        severity
        severityColor
        status
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        recognizedByUser
        recognizedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertLogsByStatus = /* GraphQL */ `
  query AlertLogsByStatus(
    $status: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertLogsByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertID
        name
        description
        severity
        severityColor
        status
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        recognizedByUser
        recognizedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertLogsByCompanyID = /* GraphQL */ `
  query AlertLogsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertLogsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertID
        name
        description
        severity
        severityColor
        status
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        recognizedByUser
        recognizedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertLogsByBranchID = /* GraphQL */ `
  query AlertLogsByBranchID(
    $branchID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertLogsByBranchID(
      branchID: $branchID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertID
        name
        description
        severity
        severityColor
        status
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        recognizedByUser
        recognizedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertLogsByDeviceID = /* GraphQL */ `
  query AlertLogsByDeviceID(
    $deviceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertLogsByDeviceID(
      deviceID: $deviceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertID
        name
        description
        severity
        severityColor
        status
        companyID
        companyName
        branchID
        branchName
        deviceID
        deviceName
        notificationsSent
        recognizedByUser
        recognizedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAlert = /* GraphQL */ `
  query GetAlert($id: ID!) {
    getAlert(id: $id) {
      id
      name
      description
      severity
      severityColor
      devices {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      smsNotifications
      wspNotifications
      emailNotifications
      conditions
      enabled
      companyID
      startSchedule
      endSchedule
      days
      execInterval
      execTime
      hourInterval
      executeOnHolidays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAlerts = /* GraphQL */ `
  query ListAlerts(
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        severity
        severityColor
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertsByCompanyID = /* GraphQL */ `
  query AlertsByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertsByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        severity
        severityColor
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeviceActionLog = /* GraphQL */ `
  query GetDeviceActionLog($id: ID!) {
    getDeviceActionLog(id: $id) {
      id
      deviceID
      actionID
      userEmail
      actionName
      actionValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeviceActionLogs = /* GraphQL */ `
  query ListDeviceActionLogs(
    $filter: ModelDeviceActionLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeviceActionLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceID
        actionID
        userEmail
        actionName
        actionValue
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deviceActionLogsByDeviceID = /* GraphQL */ `
  query DeviceActionLogsByDeviceID(
    $deviceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceActionLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deviceActionLogsByDeviceID(
      deviceID: $deviceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceID
        actionID
        userEmail
        actionName
        actionValue
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeviceAction = /* GraphQL */ `
  query GetDeviceAction($id: ID!) {
    getDeviceAction(id: $id) {
      id
      deviceID
      actionID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeviceActions = /* GraphQL */ `
  query ListDeviceActions(
    $filter: ModelDeviceActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeviceActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        deviceID
        actionID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deviceActionsByDeviceID = /* GraphQL */ `
  query DeviceActionsByDeviceID(
    $deviceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deviceActionsByDeviceID(
      deviceID: $deviceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceID
        actionID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAction = /* GraphQL */ `
  query GetAction($id: ID!) {
    getAction(id: $id) {
      id
      name
      shortName
      description
      valueType
      values
      errorMsg
      successMsg
      icon
      iconColor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActions = /* GraphQL */ `
  query ListActions(
    $filter: ModelActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        shortName
        description
        valueType
        values
        errorMsg
        successMsg
        icon
        iconColor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserPreference = /* GraphQL */ `
  query GetUserPreference($id: ID!) {
    getUserPreference(id: $id) {
      id
      userID
      dashboardStandard
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserPreferences = /* GraphQL */ `
  query ListUserPreferences(
    $filter: ModelUserPreferenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPreferences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        dashboardStandard
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userPreferencesByUserID = /* GraphQL */ `
  query UserPreferencesByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserPreferenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userPreferencesByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        dashboardStandard
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeviceVariable = /* GraphQL */ `
  query GetDeviceVariable($id: ID!) {
    getDeviceVariable(id: $id) {
      id
      deviceID
      variableID
      calibrationFactor
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDeviceVariables = /* GraphQL */ `
  query ListDeviceVariables(
    $filter: ModelDeviceVariableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeviceVariables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        deviceID
        variableID
        calibrationFactor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deviceVariablesByDeviceID = /* GraphQL */ `
  query DeviceVariablesByDeviceID(
    $deviceID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceVariableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deviceVariablesByDeviceID(
      deviceID: $deviceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        deviceID
        variableID
        calibrationFactor
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVariable = /* GraphQL */ `
  query GetVariable($id: ID!) {
    getVariable(id: $id) {
      id
      name
      description
      shortName
      derived
      unit
      groupType
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVariables = /* GraphQL */ `
  query ListVariables(
    $filter: ModelVariableFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVariables(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        shortName
        derived
        unit
        groupType
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSharedDashboard = /* GraphQL */ `
  query GetSharedDashboard($id: ID!) {
    getSharedDashboard(id: $id) {
      id
      dashboardID
      userID
      permissions
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSharedDashboards = /* GraphQL */ `
  query ListSharedDashboards(
    $filter: ModelSharedDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSharedDashboards(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dashboardID
        userID
        permissions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sharedDashboardsByDashboardID = /* GraphQL */ `
  query SharedDashboardsByDashboardID(
    $dashboardID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSharedDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sharedDashboardsByDashboardID(
      dashboardID: $dashboardID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dashboardID
        userID
        permissions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const sharedDashboardsByUserID = /* GraphQL */ `
  query SharedDashboardsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSharedDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sharedDashboardsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dashboardID
        userID
        permissions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDashboard = /* GraphQL */ `
  query GetDashboard($id: ID!) {
    getDashboard(id: $id) {
      id
      name
      description
      chartDetails
      ownerID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDashboards = /* GraphQL */ `
  query ListDashboards(
    $filter: ModelDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDashboards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        chartDetails
        ownerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dashboardsByOwnerID = /* GraphQL */ `
  query DashboardsByOwnerID(
    $ownerID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    dashboardsByOwnerID(
      ownerID: $ownerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        chartDetails
        ownerID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      id
      name
      location
      brand
      description
      companyID
      branchID
      coordsLat
      coordsLng
      timezone
      energyCost
      currency
      actionOnOff
      autoRefreshTime
      alerts {
        items {
          id
          alertId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      rules {
        items {
          id
          ruleId
          deviceId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      actionsObj
      calibration
      env
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDevices = /* GraphQL */ `
  query ListDevices(
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByCompanyID = /* GraphQL */ `
  query DevicesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const devicesByBranchID = /* GraphQL */ `
  query DevicesByBranchID(
    $branchID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    devicesByBranchID(
      branchID: $branchID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      sub
      roles {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      dashboards {
        items {
          id
          name
          description
          chartDetails
          ownerID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      isSuper
      name
      birthDate
      position
      sex
      gender
      phones
      additionalEmails
      addresses
      photoSrc
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userBySub = /* GraphQL */ `
  query UserBySub(
    $sub: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userBySub(
      sub: $sub
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const usersByCompanyID = /* GraphQL */ `
  query UsersByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    usersByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRole = /* GraphQL */ `
  query GetRole($id: ID!) {
    getRole(id: $id) {
      id
      name
      description
      permissions {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      users {
        items {
          id
          userId
          roleId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      companyID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRoles = /* GraphQL */ `
  query ListRoles(
    $filter: ModelRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rolesByCompanyID = /* GraphQL */ `
  query RolesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rolesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPermission = /* GraphQL */ `
  query GetPermission($id: ID!) {
    getPermission(id: $id) {
      id
      name
      roles {
        items {
          id
          roleId
          permissionId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPermissions = /* GraphQL */ `
  query ListPermissions(
    $filter: ModelPermissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPermissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        roles {
          nextToken
          __typename
        }
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBranch = /* GraphQL */ `
  query GetBranch($id: ID!) {
    getBranch(id: $id) {
      id
      customId
      name
      abbreviation
      address
      phone
      description
      country
      city
      companyID
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBranches = /* GraphQL */ `
  query ListBranches(
    $filter: ModelBranchFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBranches(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customId
        name
        abbreviation
        address
        phone
        description
        country
        city
        companyID
        devices {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const branchesByCompanyID = /* GraphQL */ `
  query BranchesByCompanyID(
    $companyID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBranchFilterInput
    $limit: Int
    $nextToken: String
  ) {
    branchesByCompanyID(
      companyID: $companyID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customId
        name
        abbreviation
        address
        phone
        description
        country
        city
        companyID
        devices {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      nit
      abbreviation
      address
      phone
      description
      legalRepName
      legalRepContact
      otherContacts
      branches {
        items {
          id
          customId
          name
          abbreviation
          address
          phone
          description
          country
          city
          companyID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      devices {
        items {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      country
      city
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        nit
        abbreviation
        address
        phone
        description
        legalRepName
        legalRepContact
        otherContacts
        branches {
          nextToken
          __typename
        }
        devices {
          nextToken
          __typename
        }
        country
        city
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceOrderMaintenanceRoutine = /* GraphQL */ `
  query GetServiceOrderMaintenanceRoutine($id: ID!) {
    getServiceOrderMaintenanceRoutine(id: $id) {
      id
      maintenanceRoutineId
      serviceOrderId
      maintenanceRoutine {
        id
        name
        description
        activities {
          nextToken
          __typename
        }
        companyID
        serviceOrders {
          nextToken
          __typename
        }
        activitiesOrder
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listServiceOrderMaintenanceRoutines = /* GraphQL */ `
  query ListServiceOrderMaintenanceRoutines(
    $filter: ModelServiceOrderMaintenanceRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceOrderMaintenanceRoutines(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        maintenanceRoutineId
        serviceOrderId
        maintenanceRoutine {
          id
          name
          description
          companyID
          activitiesOrder
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderMaintenanceRoutinesByMaintenanceRoutineId = /* GraphQL */ `
  query ServiceOrderMaintenanceRoutinesByMaintenanceRoutineId(
    $maintenanceRoutineId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderMaintenanceRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderMaintenanceRoutinesByMaintenanceRoutineId(
      maintenanceRoutineId: $maintenanceRoutineId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        maintenanceRoutineId
        serviceOrderId
        maintenanceRoutine {
          id
          name
          description
          companyID
          activitiesOrder
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderMaintenanceRoutinesByServiceOrderId = /* GraphQL */ `
  query ServiceOrderMaintenanceRoutinesByServiceOrderId(
    $serviceOrderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderMaintenanceRoutineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderMaintenanceRoutinesByServiceOrderId(
      serviceOrderId: $serviceOrderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        maintenanceRoutineId
        serviceOrderId
        maintenanceRoutine {
          id
          name
          description
          companyID
          activitiesOrder
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceOrderTool = /* GraphQL */ `
  query GetServiceOrderTool($id: ID!) {
    getServiceOrderTool(id: $id) {
      id
      toolId
      serviceOrderId
      tool {
        id
        name
        description
        location
        companyID
        technicianID
        serviceOrders {
          nextToken
          __typename
        }
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listServiceOrderTools = /* GraphQL */ `
  query ListServiceOrderTools(
    $filter: ModelServiceOrderToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceOrderTools(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        toolId
        serviceOrderId
        tool {
          id
          name
          description
          location
          companyID
          technicianID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderToolsByToolId = /* GraphQL */ `
  query ServiceOrderToolsByToolId(
    $toolId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderToolsByToolId(
      toolId: $toolId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        toolId
        serviceOrderId
        tool {
          id
          name
          description
          location
          companyID
          technicianID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderToolsByServiceOrderId = /* GraphQL */ `
  query ServiceOrderToolsByServiceOrderId(
    $serviceOrderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderToolsByServiceOrderId(
      serviceOrderId: $serviceOrderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        toolId
        serviceOrderId
        tool {
          id
          name
          description
          location
          companyID
          technicianID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceOrderEquipment = /* GraphQL */ `
  query GetServiceOrderEquipment($id: ID!) {
    getServiceOrderEquipment(id: $id) {
      id
      serviceOrderId
      equipmentId
      serviceOrder {
        id
        code
        description
        billDate
        billValue
        billCurrency
        companyID
        branchID
        equipments {
          nextToken
          __typename
        }
        equipmentRoutines {
          equipmentID
          routineID
          __typename
        }
        equipmentSpares {
          equipmentID
          spares
          __typename
        }
        costCenterID
        title
        color
        observations
        userExecutor
        status
        start
        end
        tools {
          nextToken
          __typename
        }
        spares {
          nextToken
          __typename
        }
        maintenanceRoutines {
          nextToken
          __typename
        }
        auxExecutors
        geolocation
        photoRequired
        createdAt
        deletedAt
        updatedAt
        __typename
      }
      equipment {
        id
        name
        location
        description
        companyID
        branchID
        deviceID
        spares {
          nextToken
          __typename
        }
        serviceOrders {
          nextToken
          __typename
        }
        coordsLat
        coordsLng
        routineID
        deletedAt
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listServiceOrderEquipments = /* GraphQL */ `
  query ListServiceOrderEquipments(
    $filter: ModelServiceOrderEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServiceOrderEquipments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderId
        equipmentId
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        equipment {
          id
          name
          location
          description
          companyID
          branchID
          deviceID
          coordsLat
          coordsLng
          routineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderEquipmentsByServiceOrderId = /* GraphQL */ `
  query ServiceOrderEquipmentsByServiceOrderId(
    $serviceOrderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderEquipmentsByServiceOrderId(
      serviceOrderId: $serviceOrderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderId
        equipmentId
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        equipment {
          id
          name
          location
          description
          companyID
          branchID
          deviceID
          coordsLat
          coordsLng
          routineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const serviceOrderEquipmentsByEquipmentId = /* GraphQL */ `
  query ServiceOrderEquipmentsByEquipmentId(
    $equipmentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceOrderEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    serviceOrderEquipmentsByEquipmentId(
      equipmentId: $equipmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        serviceOrderId
        equipmentId
        serviceOrder {
          id
          code
          description
          billDate
          billValue
          billCurrency
          companyID
          branchID
          costCenterID
          title
          color
          observations
          userExecutor
          status
          start
          end
          auxExecutors
          geolocation
          photoRequired
          createdAt
          deletedAt
          updatedAt
          __typename
        }
        equipment {
          id
          name
          location
          description
          companyID
          branchID
          deviceID
          coordsLat
          coordsLng
          routineID
          deletedAt
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRuleDevice = /* GraphQL */ `
  query GetRuleDevice($id: ID!) {
    getRuleDevice(id: $id) {
      id
      ruleId
      deviceId
      rule {
        id
        name
        description
        action
        actionValue
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRuleDevices = /* GraphQL */ `
  query ListRuleDevices(
    $filter: ModelRuleDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRuleDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ruleId
        deviceId
        rule {
          id
          name
          description
          action
          actionValue
          smsNotifications
          wspNotifications
          emailNotifications
          conditions
          enabled
          companyID
          startSchedule
          endSchedule
          days
          execInterval
          execTime
          hourInterval
          executeOnHolidays
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ruleDevicesByRuleId = /* GraphQL */ `
  query RuleDevicesByRuleId(
    $ruleId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ruleDevicesByRuleId(
      ruleId: $ruleId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        deviceId
        rule {
          id
          name
          description
          action
          actionValue
          smsNotifications
          wspNotifications
          emailNotifications
          conditions
          enabled
          companyID
          startSchedule
          endSchedule
          days
          execInterval
          execTime
          hourInterval
          executeOnHolidays
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const ruleDevicesByDeviceId = /* GraphQL */ `
  query RuleDevicesByDeviceId(
    $deviceId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRuleDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ruleDevicesByDeviceId(
      deviceId: $deviceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ruleId
        deviceId
        rule {
          id
          name
          description
          action
          actionValue
          smsNotifications
          wspNotifications
          emailNotifications
          conditions
          enabled
          companyID
          startSchedule
          endSchedule
          days
          execInterval
          execTime
          hourInterval
          executeOnHolidays
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAlertDevice = /* GraphQL */ `
  query GetAlertDevice($id: ID!) {
    getAlertDevice(id: $id) {
      id
      alertId
      deviceId
      alert {
        id
        name
        description
        severity
        severityColor
        devices {
          nextToken
          __typename
        }
        smsNotifications
        wspNotifications
        emailNotifications
        conditions
        enabled
        companyID
        startSchedule
        endSchedule
        days
        execInterval
        execTime
        hourInterval
        executeOnHolidays
        createdAt
        updatedAt
        __typename
      }
      device {
        id
        name
        location
        brand
        description
        companyID
        branchID
        coordsLat
        coordsLng
        timezone
        energyCost
        currency
        actionOnOff
        autoRefreshTime
        alerts {
          nextToken
          __typename
        }
        rules {
          nextToken
          __typename
        }
        actionsObj
        calibration
        env
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAlertDevices = /* GraphQL */ `
  query ListAlertDevices(
    $filter: ModelAlertDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlertDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        alertId
        deviceId
        alert {
          id
          name
          description
          severity
          severityColor
          smsNotifications
          wspNotifications
          emailNotifications
          conditions
          enabled
          companyID
          startSchedule
          endSchedule
          days
          execInterval
          execTime
          hourInterval
          executeOnHolidays
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertDevicesByAlertId = /* GraphQL */ `
  query AlertDevicesByAlertId(
    $alertId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertDevicesByAlertId(
      alertId: $alertId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertId
        deviceId
        alert {
          id
          name
          description
          severity
          severityColor
          smsNotifications
          wspNotifications
          emailNotifications
          conditions
          enabled
          companyID
          startSchedule
          endSchedule
          days
          execInterval
          execTime
          hourInterval
          executeOnHolidays
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const alertDevicesByDeviceId = /* GraphQL */ `
  query AlertDevicesByDeviceId(
    $deviceId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAlertDeviceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alertDevicesByDeviceId(
      deviceId: $deviceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertId
        deviceId
        alert {
          id
          name
          description
          severity
          severityColor
          smsNotifications
          wspNotifications
          emailNotifications
          conditions
          enabled
          companyID
          startSchedule
          endSchedule
          days
          execInterval
          execTime
          hourInterval
          executeOnHolidays
          createdAt
          updatedAt
          __typename
        }
        device {
          id
          name
          location
          brand
          description
          companyID
          branchID
          coordsLat
          coordsLng
          timezone
          energyCost
          currency
          actionOnOff
          autoRefreshTime
          actionsObj
          calibration
          env
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRoleUser = /* GraphQL */ `
  query GetRoleUser($id: ID!) {
    getRoleUser(id: $id) {
      id
      userId
      roleId
      user {
        id
        email
        sub
        roles {
          nextToken
          __typename
        }
        dashboards {
          nextToken
          __typename
        }
        companyID
        isSuper
        name
        birthDate
        position
        sex
        gender
        phones
        additionalEmails
        addresses
        photoSrc
        createdAt
        updatedAt
        __typename
      }
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRoleUsers = /* GraphQL */ `
  query ListRoleUsers(
    $filter: ModelRoleUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoleUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        roleId
        user {
          id
          email
          sub
          companyID
          isSuper
          name
          birthDate
          position
          sex
          gender
          phones
          additionalEmails
          addresses
          photoSrc
          createdAt
          updatedAt
          __typename
        }
        role {
          id
          name
          description
          companyID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const roleUsersByUserId = /* GraphQL */ `
  query RoleUsersByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoleUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roleUsersByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        roleId
        user {
          id
          email
          sub
          companyID
          isSuper
          name
          birthDate
          position
          sex
          gender
          phones
          additionalEmails
          addresses
          photoSrc
          createdAt
          updatedAt
          __typename
        }
        role {
          id
          name
          description
          companyID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const roleUsersByRoleId = /* GraphQL */ `
  query RoleUsersByRoleId(
    $roleId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRoleUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roleUsersByRoleId(
      roleId: $roleId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        roleId
        user {
          id
          email
          sub
          companyID
          isSuper
          name
          birthDate
          position
          sex
          gender
          phones
          additionalEmails
          addresses
          photoSrc
          createdAt
          updatedAt
          __typename
        }
        role {
          id
          name
          description
          companyID
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRolePermission = /* GraphQL */ `
  query GetRolePermission($id: ID!) {
    getRolePermission(id: $id) {
      id
      roleId
      permissionId
      role {
        id
        name
        description
        permissions {
          nextToken
          __typename
        }
        users {
          nextToken
          __typename
        }
        companyID
        createdAt
        updatedAt
        __typename
      }
      permission {
        id
        name
        roles {
          nextToken
          __typename
        }
        description
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRolePermissions = /* GraphQL */ `
  query ListRolePermissions(
    $filter: ModelRolePermissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRolePermissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        roleId
        permissionId
        role {
          id
          name
          description
          companyID
          createdAt
          updatedAt
          __typename
        }
        permission {
          id
          name
          description
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rolePermissionsByRoleId = /* GraphQL */ `
  query RolePermissionsByRoleId(
    $roleId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRolePermissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rolePermissionsByRoleId(
      roleId: $roleId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roleId
        permissionId
        role {
          id
          name
          description
          companyID
          createdAt
          updatedAt
          __typename
        }
        permission {
          id
          name
          description
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const rolePermissionsByPermissionId = /* GraphQL */ `
  query RolePermissionsByPermissionId(
    $permissionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRolePermissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    rolePermissionsByPermissionId(
      permissionId: $permissionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roleId
        permissionId
        role {
          id
          name
          description
          companyID
          createdAt
          updatedAt
          __typename
        }
        permission {
          id
          name
          description
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
